import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Fieldtypes } from '../../../../../../../core/entities/fieldtypes.model';
import { FieldtypesService } from '../../../../../../../core/repositories/fieldtypes.service'
import { TIPO_DATO_FIELDTYPE, ALIGN, TIPO_FORMATO} from '../../../../../../../core/utils/constants';

@Injectable()
export class EditDialogsFieldtypesService {

  fieldtypes: Fieldtypes = new Fieldtypes();
  originalFieldtypes: Fieldtypes = new Fieldtypes();
  parametersInput: Fieldtypes = new Fieldtypes();

  allFieldtypes: Fieldtypes[] = [];
  changetitulo: boolean = false;

  tipodato: any[] = TIPO_DATO_FIELDTYPE;
  tipoalign: any[] = ALIGN;
  tipoformato: any[] = TIPO_FORMATO;

  constructor(private fieldtypesService: FieldtypesService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.fieldtypes = data.fieldtype;
    this.changetitulo = data.titulochange;
    this.originalFieldtypes = _.cloneDeep(this.fieldtypes);
    console.log(data);
    return this.fieldtypesService.findAll().pipe(map((result: Fieldtypes[]) => {
      this.allFieldtypes = result;
      if (Utils.noUndfAndNull(data.fieldtype)) {
        this.fieldtypes = _.cloneDeep(data.fieldtype);
      }
      return true;
    }));
  }


  /**
  * @description
  * Guarda el fieldtype
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    if (Utils.noUndfAndNull(this.fieldtypes.id, "")) {

      /*comparamos el fieldtype original con el modificado*/
      let compareFieldtype = this.compare(this.fieldtypes, this.originalFieldtypes);

      if(compareFieldtype){
        return of(-1);
      }else{
        return this.fieldtypesService.postFieldtype(this.fieldtypes);
      }

    }else{
      return this.fieldtypesService.postFieldtype(this.fieldtypes);
    }
  }

  /**
  * @description
  * Comprueba si dos Fieldtypes son iguales.
  * @param datoX fieldtype 1
  * @param datoY fieldtype 2
  * @returns True si son iguales
  */
  public compare(itemX:Fieldtypes, itemY:Fieldtypes):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

      if (itemX.typefld !== null) {
        let value = itemX.typefld.toString();
        if (value === 'null') {
          itemX.typefld = 0;
        }
      }
      if (itemX.align !== undefined) {
        if (itemX.align !== null) {
          let value = itemX.align.toString();
          if (value === 'null') {
            itemX.align = "";
          }
        }
      }
      if (itemX.format !== null) {
        let value = itemX.format.toString();
        if (value === 'null') {
          itemX.format = 0;
        }
      }

      if ((!Utils.compareTextOrNumber(itemX.code, itemY.code)
      || !Utils.compareTextOrNumber(itemX.desc, itemY.desc)
      || !Utils.compareTextOrNumber(itemX.url, itemY.url)
      || !Utils.compareTextOrNumber(itemX.formatout, itemY.formatout)
      || !Utils.compareTextOrNumber(itemX.formatoutes, itemY.formatoutes)
      || !Utils.compareTextOrNumber(itemX.precision, itemY.precision)
      || !Utils.compareTextOrNumber(itemX.unit, itemY.unit)
      || !Utils.compareTextOrNumber(itemX.typefld, itemY.typefld)
      || !Utils.compareTextOrNumber(itemX.align, itemY.align)
      || !Utils.compareTextOrNumber(itemX.format, itemY.format)
      || !Utils.compareTextOrNumber(itemX.roundvalue, itemY.roundvalue)
      || !Utils.compareTextOrNumber(itemX.separator, itemY.separator)
      || !Utils.compareTextOrNumber(itemX.delimiter, itemY.delimiter))
      && (itemX.code !== ""
      && itemX.desc !== ""
      && Utils.noUndfAndNull(itemX.typefld)
      && Utils.noUndfAndNull(itemX.align)))
        return false;
    }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
      return false;
    }
    return true;
  }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.fieldtypes = new Fieldtypes();
  }

}
